export default __webpack_public_path__ + "static/media/Scratch That.95004758.png";